var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.72,
    d: "M5.57041 11.75C5.88291 12.0625 6.41416 12.0625 6.72666 11.75L15.9142 2.5625C16.2267 2.25 16.2267 1.71875 15.9142 1.40625L14.7892 0.28125C14.4767 -0.03125 13.9767 -0.03125 13.6642 0.28125L6.16416 7.78125L2.63291 4.28125C2.32041 3.96875 1.82041 3.96875 1.50791 4.28125L0.382908 5.40625C0.0704083 5.71875 0.0704083 6.25 0.382908 6.5625L5.57041 11.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.6615ae79b8e26818d5fd04a96114e8c7.svg";
export { ForwardRef as ReactComponent };